import React, { Component } from "react";
import { connect } from "react-redux";
import * as baroloActions from "../../store/actions/Index";
import * as informativeTextsActions from "../../store/actions/InformativeTexts";
import * as authActions from "../../store/actions/auth";
import * as ActionTypes from "../../store/actions/ActionTypes";
import Form from "../../containers/Form/Form";
import Tourism from "../Tourism/Tourism";
import AppBar from "../../components/AppBar/AppBar";
import Container from "@material-ui/core/Container";
import SideMenu from "../../components/SideMenu/SideMenu";
import DecisionModal from "../../components/DecisionModal/DecisionModal";
import ModifyModal from "../../containers/ModalModify/ModalModify";
import ModifyTextModal from "../../containers/ModifyTextForm/ModifyTextForm";
import InformativeTexts from "../InformativeTexts/InformativeTexts";

class Manager extends Component {
  state = {
    fieldValues: {
      image: ""
    },
    loading: false,
    decisionModalOpen: false,
    modifyFormModalOpen: false,
    modifyTextFormOpen: false,
    idToDelete: 0,
    idToUpdate: 0,
    deleting: false,
    types: [
      {
        id: 0,
        type: "Turismo"
      },
      {
        id: 1,
        type: "Noticias"
      },
      {
        id: 2,
        type: "Eventos"
      },
      {
        id: 3,
        type: "Home"
      },
      {
        id: 4,
        type: "Visitas Guiadas"
      }
    ]
  };

  componentDidMount() {
    this.props.onLoadTourismEvents();
    this.props.onLoadInformativeTexts();
  }

  handleSideMenu = () => {
    this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
  };

  showDecisionModal = idToDelete => {
    this.setState({
      deleting: true,
      decisionModalOpen: true,
      idToDelete: idToDelete
    });
  };

  hiddeDecisionModal = () => {
    this.setState({ deleting: false, decisionModalOpen: false });
  };

  handleEditModal = event => {
    this.setState({ modifyFormModalOpen: true });
    this.props.onSetModifyTourismEvent(event);
  };

  handleCloseModifyModal = () => {
    this.setState({ modifyFormModalOpen: false });
  };

  handleEditTextModal = event => {
    this.setState({ modifyTextFormOpen: true });
    this.props.onSetModifyInformativeText(event);
  };

  handleCloseModifyTextForm = () => {
    this.setState({ modifyTextFormOpen: false });
  };

  render() {
    const containerStyle = {
      marginTop: "50px"
    };

    let textsMenu =
      this.props.informativeTexts && this.props.textsMenuOpen ? (
        <InformativeTexts
          texts={this.props.informativeTexts}
          onClickEditButton={this.handleEditTextModal}
        />
      ) : null;

    let tourism =
      this.props.tourismEvents && this.props.listMenuOpen ? (
        <Tourism
          list={this.props.tourismEvents}
          onClickDeleteButton={this.showDecisionModal}
          onClickEditButton={this.handleEditModal}
        />
      ) : null;

    let createForm = this.props.formMenuOpen ? (
      <Form
        element="Evento"
        fieldValues={this.state.fieldValues}
        onUploadImage={this.props.onUploadImageAndCreateEvent}
        types={this.state.types}
      />
    ) : null;

    let modifyForm = this.state.modifyFormModalOpen ? (
      <ModifyModal
        show={
          this.state.modifyFormModalOpen && this.props.eventToModify.id !== 0
        }
        eventToModify={this.props.eventToModify}
        types={this.state.types}
        onClickUpdateButton={this.props.handleModifyTourismEvent}
        onClose={this.handleCloseModifyModal}
        fieldValues={this.state.fieldValues}
        onModifyImage={this.props.onUploadImage}
      />
    ) : null;

    let modifyTextForm = this.state.modifyTextFormOpen ? (
      <ModifyTextModal
        show={this.state.modifyTextFormOpen && this.props.textToModify.id !== 0}
        textToModify={this.props.textToModify}
        onClickUpdateButton={this.props.handleModifyInformativeText}
        onClose={this.handleCloseModifyTextForm}
      />
    ) : null;

    if (this.props.deleteEvent) {
      this.props.onLoadTourismEvents();
      this.props.handleOpenList();
      this.props.onFinishedDeleteTourismEvent();
    }

    if (this.props.createEvent) {
      this.props.onLoadTourismEvents();
      this.props.handleOpenList();
      this.props.onFinishedCreateTourismEvent();
    }

    if (this.props.modifyEvent) {
      this.props.onLoadTourismEvents();
      this.props.handleOpenList();
      this.setState({ modifyFormModalOpen: false });
      this.props.onFinishedModifyTourismEvent();
    }

    if (this.props.modifyInformativeText) {
      this.props.onLoadInformativeTexts();
      this.props.handleOpenTextList();
      this.setState({ modifyTextFormOpen: false });
      this.props.onFinishedModifyInformativeText();
    }

    return (
      <div>
        {modifyForm}
        {modifyTextForm}
        <AppBar
          openMenu={this.props.handleOpenSideMenu}
          onClickLogout={this.props.handleLogout}
        />
        <SideMenu
          open={this.props.sideMenuOpen}
          handleOpenList={this.props.handleOpenList}
          handleOpenForm={this.props.handleOpenForm}
          handleOpenTextEdit={this.props.handleOpenTextList}
        />
        <Container fixed style={containerStyle}>
          {createForm}
          {tourism}
          {textsMenu}
        </Container>
        <DecisionModal
          show={this.state.decisionModalOpen}
          handleYesDecision={() =>
            this.props.onDeleteTourismEvent(this.state.idToDelete)
          }
          closeModal={this.hiddeDecisionModal}
          handleNoDecision={this.hiddeDecisionModal}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    tourismEvents: state.reducer.tourismEvents,
    informativeTexts: state.reducer.informativeTexts,
    sideMenuOpen: state.reducer.sideMenuOpen,
    listMenuOpen: state.reducer.listMenuOpen,
    textsMenuOpen: state.reducer.textMenuOpen,
    formMenuOpen: state.reducer.formMenuOpen,
    createEvent: state.reducer.creatingEvent,
    deleteEvent: state.reducer.deletingElement,
    modifyEvent: state.reducer.modifyingElement,
    modifyInformativeText: state.reducer.modifyingInformativeText,
    eventToModify: state.reducer.eventToModify,
    textToModify: state.reducer.textToModify
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadTourismEvents: () => dispatch(baroloActions.loadTourismEvents()),
    onLoadInformativeTexts: () =>
      dispatch(informativeTextsActions.loadInformativeTexts()),
    onCreateTourismEvent: tourismEvent =>
      dispatch(baroloActions.createTourismEvent(tourismEvent)),
    onFinishedCreateTourismEvent: () =>
      dispatch({ type: ActionTypes.ONFINISHED_CREATE_TOURISMEVENT }),
    onUploadImage: (formData, config, newEvent) =>
      dispatch(baroloActions.uploadImage(formData, config, newEvent)),
    onUploadImageAndCreateEvent: (formData, config, newEvent) =>
      dispatch(
        baroloActions.uploadImageAndCreateEvent(formData, config, newEvent)
      ),
    onDeleteTourismEvent: idToDelete =>
      dispatch(baroloActions.deleteTourismEvent(idToDelete)),
    onFinishedDeleteTourismEvent: () =>
      dispatch({ type: ActionTypes.ONFINISHED_DELETE_TOURISMEVENT }),
    onSetModifyTourismEvent: eventToModify =>
      dispatch({
        type: ActionTypes.SET_MODIFY_TOURISMEVENT,
        eventToModify: eventToModify
      }),
    onFinishedModifyTourismEvent: () =>
      dispatch({ type: ActionTypes.ONFINISHED_MODIFY_TOURISMEVENT }),
    handleModifyTourismEvent: event =>
      dispatch(baroloActions.updateTourismEvent(event)),
    onSetModifyInformativeText: textToModify =>
      dispatch({
        type: ActionTypes.SET_MODIFY_INFORMATIVETEXT,
        informativeText: textToModify
      }),
    onFinishedModifyInformativeText: () =>
      dispatch({ type: ActionTypes.ONFINISHED_MODIFY_INFORMATIVETEXT }),
    handleModifyInformativeText: event =>
      dispatch(informativeTextsActions.updateInformativeText(event)),
    handleOpenSideMenu: () =>
      dispatch({ type: ActionTypes.OPENCLOSE_SIDEMENU }),
    handleOpenForm: () => dispatch({ type: ActionTypes.OPEN_FORMMENU }),
    handleOpenList: () => dispatch({ type: ActionTypes.OPEN_LISTMENU }),
    handleOpenTextList: () => dispatch({ type: ActionTypes.OPEN_TEXTSMENU }),
    handleLogout: () => dispatch(authActions.authLogOut())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
